module.exports = "<div class=\"message\">\n  Vous n'êtes pas autorisé à accéder à ce contenu !\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/authentication.component.html
// module id = ./src/app/authentication/authentication.component.html
// module chunks = main